import type { ReactNode } from "react";

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      {children}
    </label>
  );
}

export function ErrorText({ error }: { error: unknown }) {
  if (!error) return null;
  const msg = error instanceof Error ? error.message : String(error);
  return <p className="error">{msg}</p>;
}

export const yen = (n: number | null | undefined): string => (n == null ? "-" : `${n.toLocaleString("ja-JP")}円`);

export const marginTypeLabel: Record<string, string> = {
  seido: "制度",
  ippan_short: "一般（短期）",
  ippan_long: "一般（無期限）",
};

export const stateLabel: Record<string, string> = {
  waiting: "到着待ち",
  on_hand: "手元",
  used: "使用済み",
};

export const statusLabel: Record<string, string> = {
  planned: "予定",
  executed: "実績",
  not_executed: "未実施",
};
